import { ratioWxHCalculation } from '../../ratio/ratio-height-calculator';
import { imageAddCropParameters } from './image-add-crop-parameters';

export function imageShopifySrcGenerator(url: string, ratio: string, breakpoint: number, itemsPerRow: number): string {
  const pixelWidth = Math.round(breakpoint / itemsPerRow);
  const WxH = ratioWxHCalculation(pixelWidth, ratio);
  return `${imageAddCropParameters(url, `${WxH}`)}`;
}
